import React, { useState, useEffect } from "react";
import { DatePicker, Button, Dropdown, Tooltip, notification } from "antd";
import Table from "./table/DailyStatsReportTable";
import { HiOutlineInboxArrowDown } from "react-icons/hi2";
import { DownOutlined } from "@ant-design/icons";
import { CSVLink } from "react-csv";
import dayjs from "dayjs";
import dailyStatsFilter from "./DailyStatsFilter";
import Utils from "../../../utility/Utils";
import { useReportsStore } from "../ReportsStore";
import { useSearchParams } from "react-router-dom";
import "../reports.scss";
import dbstorage from "../../../lib/DBStorage";

import notificationFilter from "../../../components/NotificationFilter";
import { useComponentStore } from "../../../components/ComponentsStore";
const DailyStatsReport = () => {
  const yesterday = dayjs().subtract(1, "day");

  const [userGroup, setUserGroup] = useState("users");
  const [tableData, setTableData] = useState([]);
  const [searchParams, setSearchParams] = useSearchParams();
  const [loading, setLoading] = useState(true);
  const {
    dailyStatsReportUserType,
    setDailyStatsReportUserType,
    dailyStatsReportFirstRender,
    setDailyStatsFirstRender,
    dailyStatsReportSelectFilter,
    setDailyStatsReportSelectFilter,
  } = useReportsStore();
  const { setNotificationCount } = useComponentStore();
  const labelToValueMapping = {
    "All USERS": "users",
    ADMIN: "admin",
    PROD: "users",
    TEST: "test",
  };

  const headers = [
    { label: "Serial Number", key: "serialnumber" },
    { label: "GW Created", key: "gateway_created" },
    { label: "GW Model", key: "gateway_model" },
    { label: "GW Name", key: "gateway_name" },
    { label: "GW Owner", key: "gateway_owner" },
    { label: "GW Current Status", key: "gateway_current_status" },
    { label: "GW Offline Time", key: "gateway_last_offline" },
    { label: "GW Offline in Last 24 Hrs", key: "gateway_offline_count" },
    { label: "Smartcable Status", key: "smartcable_status" },
    {
      label: "SC Offline Time If Offline For More Than 24 Hrs",
      key: "sc_last_offline",
    },
    { label: "SC Offline In Last 24 Hours", key: "sc_offline_count" },
    { label: "Total Floor", key: "floors" },
    { label: "Total Room", key: "rooms" },
    { label: "Total Sensor", key: "sensors" },
    { label: "Total Zigbee EndDevice", key: "zigbee_sensors" },
    { label: "Total Zigbee Router", key: "zigbee_routers" },
    { label: "Total Offline Zigbee Router", key: "zigbee_routers_offline" },
    { label: "Total Wise Sensor", key: "wise_sensors" },
    { label: "Total Local Wise Sensor", key: "local_wise_sensors" },
    { label: "Total Remote Wise Sensor", key: "remote_wise_sensors" },
    { label: "Total Camera", key: "cameras" },
    { label: "Total Sensor Offline", key: "sensors_offline" },
    { label: "Total Camera Offline", key: "cameras_offline" },
    { label: "Total Alarm", key: "alarms" },
    {
      label: "Unstable Devices (offline more than 5 times a day)",
      key: "unstable_sensors",
    },
    { label: "Total Secondary Users", key: "secondary_user" },
  ];

  const selectOptions = {
    value: dailyStatsReportUserType,
    items: [
      { key: 1, label: "All USERS" },
      { key: 2, label: "PROD" },
      { key: 3, label: "TEST" },
      { key: 4, label: "ADMIN" },
    ],

    setFilter: ({ key }) => {
      const val = selectOptions.items.find((e) => {
        return e.key === Number(key);
      }).label;
      setDailyStatsReportUserType(val);
      setUserGroup(labelToValueMapping[val]);
    },
  };

  const handleDatePicker = (date) => {
    if (date) {
      setDailyStatsReportSelectFilter(date);
      return;
    }
    setDailyStatsReportSelectFilter(dayjs().subtract(1, "day"));
  };

  const disableFutureDate = (current) => {
    return current && current.isAfter(yesterday);
  };

  const fetchData = async () => {
    try {
      setLoading(true);
      if (dailyStatsReportFirstRender) {
        let selectFilter = searchParams.get("dailyStatsReportSelectFilter");
        let userType = searchParams.get("dailyStatsReportUserType");
        if (
          selectFilter !== undefined &&
          selectFilter?.length > 0 &&
          userType?.length > 0
        ) {
          setDailyStatsReportSelectFilter(dayjs(selectFilter));
          setDailyStatsReportUserType(userType);
        } else if (selectFilter !== undefined && selectFilter?.length > 0) {
          setDailyStatsReportSelectFilter(dayjs(selectFilter));
        } else if (userType?.length > 0) {
          setDailyStatsReportUserType(userType);
        }
        setDailyStatsFirstRender(false);
      }
      const dailyStatsData = await dailyStatsFilter.getDailyStatsReport(
        dailyStatsReportSelectFilter,
        userGroup
      );
      setTableData(dailyStatsData);
    } catch (err) {
    } finally {
      setLoading(false);
    }
  };
  const updateQueryParams = () => {
    setSearchParams({
      dailyStatsReportSelectFilter:
        dailyStatsReportSelectFilter !== null
          ? dayjs(dailyStatsReportSelectFilter).format("DD-MM-YYYY")
          : "",
      dailyStatsReportUserType: dailyStatsReportUserType,
    });
  };
  const [api, contextHolder] = notification.useNotification();
  const noDataNotification = () => {
    api.info({ title: "No Data Available !",
      placement: "bottomRight",
      style: { backgroundColor: "#ceddf5" },
      duration: 2,
    });
  };
  const handleDownloadClick = async () => {
    if (!tableData.length) {
      noDataNotification();
      return;
    } else {
      await download();
    }
  };
  const download = async () => {
    try {
      let userid;
      await dbstorage.get("user").then((user) => {
        userid = user._id;
      });
      const date = dailyStatsReportSelectFilter;
      console.log(date);
      await notificationFilter.createCsv(
        "stats_report",
        userid,
        "",
        userGroup,
        date,
        ""
      );
      const count = await notificationFilter.getCount(userid);

      setNotificationCount(count.count);

      // return transformedCsvData;
    } catch (error) {
      console.error(error);
    }
  };
  useEffect(() => {
    if (!dailyStatsReportFirstRender) {
      updateQueryParams();
    }
  }, [dailyStatsReportSelectFilter, dailyStatsReportUserType]);

  useEffect(() => {
    fetchData();
  }, [dailyStatsReportSelectFilter, dailyStatsReportUserType]);

  return (
    <>
      <div className="card-background">
        <div className="d-flex justify-content-between mb-3 align-items-center">
          <div className="search-filter card-heading d-flex">
            <DatePicker
              value={dailyStatsReportSelectFilter}
              allowClear={false}
              onChange={handleDatePicker}
              disabledDate={disableFutureDate}
              format="DD-MM-YYYY"
            />
            <Dropdown
              className="drop-down shadow-sm mx-md-3"
              menu={{
                items: selectOptions.items,
                onClick: selectOptions.setFilter,
              }}
              placement="bottomLeft"
            >
              <Button>
                {selectOptions.value}
                <DownOutlined />
              </Button>
            </Dropdown>
            <div className="my-auto">
              Daily Stats Report ({dailyStatsReportSelectFilter.$d.getDate()}-
              {dailyStatsReportSelectFilter.$d.getMonth() + 1}-
              {dailyStatsReportSelectFilter.$d.getFullYear()})
            </div>
          </div>
          <Button
            className="border-0 shadow-none me-4"
            icon={
              <Tooltip title="Download">
                <span>
                  <HiOutlineInboxArrowDown className="text-color-grey fs-4" />
                </span>
              </Tooltip>
            }
            type="text"
            onClick={handleDownloadClick}
          />
        </div>
        <Table tableData={tableData} />
      </div>
    </>
  );
};

export default DailyStatsReport;
